<template>
  <footer class="footer" :class="{ [`footer-${type}`]: type }" :data-background-color="backgroundColor">
    <div class="container">
      <!-- <nav>
         <ul>
          <li>
            <a href="todo">todo</a>
          </li>
          <li>
            <a href="todo">About Us</a>
          </li>
          <li>
            <a href="todo">Blog</a>
          </li>
          <li>
            <a href="todo">Licenses</a>
          </li>
        </ul>
      </nav>-->
      <div class="copyright">
        &copy; 2017 - {{ year }}, made with <md-icon>favorite</md-icon>&nbsp;&nbsp;by Dear Future.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
